export default __webpack_public_path__ + "static/media/group-login.7409d87b.svg";